import React, { Component } from "react";

import { CButton, CSpinner } from "@coreui/react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import JitsiStudent from "../../../../components/Jitsi/student";
import JitsiTeacher from "../../../../components/Jitsi/teacher";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import "./styles.css";

const Dropbox = require("dropbox");

class ClassroomJitsi extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recording: "stopped",
      jitsiObj: null,
      room: null,
      loading: true
    };
  }

  getJitsiRoomName() {
    if (!this.state.room) return "";

    const removeSpecial = str => {
      if (str === null) return "";

      str = str.toLowerCase();
      str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      str = str.replace(/[^\w\s]/gi, "");

      return str.replace(" ", "");
    };

    return `${removeSpecial(this.state.room.room.name)}-geral`;
  }

  error(response) {
    toastr.error("Falha", response);
  }

  componentDidMount() {
    axios
      .get(
        `${URL.api}community/room/singleView/${this.props.match.params.id}`,
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      )
      .then(
        resp => {
          this.setState({
            room: resp.data.data,
            loading: false
          });
        },
        error => {
          this.error("Não foi possível entrar na reunião");
        }
      );

    if (this.props.general.active_roles.role_id !== 7) {
      const accessToken =
        "rPBbXAhYoLUAAAAAAAAAAdyTictsKm-4CKuVCU3UVvnvxh11jSGVFjwJxsjZMqpM";

      this.dbx = new Dropbox.Dropbox({ accessToken });
    }
  }

  startRecording() {
    this.state.jitsiObj.executeCommand("startRecording", {
      mode: "file", // recording mode, either `file` or `stream`.
      dropboxToken:
        "G4iT-YvT89EAAAAAAAAAATWTYTblO14JCRYNjWyZ1pFqurouqiGQDVXc6M2rqkR3" // Generated access token
    });

    this.setState({ recording: "starting" });
  }

  stopRecording() {
    this.state.jitsiObj.executeCommand("stopRecording", "file");
    this.setState({ recording: "stopping" });
  }

  onStartRecording() {
    this.setState({ recording: "started" });
  }

  onStopRecording() {
    this.setState({ recording: "saving" });

    const { name } = this.state.room.room;

    const dropBd = async nome => {
      const caminho = await this.dbx.filesListFolder({
        path: "/recordings"
      });

      let nomeDaSala = nome;
      const arquivos = caminho.result.entries; // array de de objetos(files)
      const ultimoArquivo = arquivos.length - 1; // posicao do último arquivo no array

      let pathDoArquivo;
      for (let i = ultimoArquivo; i >= 0; i--) {
        let nomeDoArquivo = arquivos[i].name;
        let nomeTratado = nomeDoArquivo.slice(0, nomeDaSala.length);

        if (nomeTratado === nomeDaSala) {
          pathDoArquivo = arquivos[i].path_lower;
          break;
        }
      }

      this.dbx
        .sharingCreateSharedLinkWithSettings({ path: pathDoArquivo })
        .then(response => {
          const retornoUrl = response.result.url;

          axios
            .post(
              `${URL.api}community/room_recording/insertJitsi`,
              { room_id: this.props.match.params.id, link: retornoUrl },
              { headers: { Authorization: `Bearer ${this.props.user.token}` } }
            )
            .then(
              resp => {
                if (!resp.data.success) {
                  this.error("Não foi possível salvar a gravação!");
                }
                this.setState({ recording: "stopped" });
              },
              error => {
                this.error("Não foi possível salvar a gravação!");
                this.setState({ recording: "stopped" });
              }
            );
        })
        .catch(error => {
          alert("Já existe um link compartilhável para essa URL");
          this.setState({ recording: "stopped" });
        });
    };

    setTimeout(() => {
      dropBd(name);
    }, 11200);
  }

  render() {
    return (
      <div className="w-100 d-flex flex-column" style={{ height: "100vh" }}>
        <div className="d-flex align-items-center bg-white p-3">
          <h4 className="mb-0">
            Sala de aula{" "}
            {this.state.room ? ` da turma ${this.state.room.room.name}` : ""}
          </h4>
          {this.props.general.active_roles.role_id !== 7 && (
            <CButton
              color={
                ["started", "stopping", "saving"].includes(this.state.recording)
                  ? "danger"
                  : "modal"
              }
              className="d-flex justify-content-center align-items-center px-2 py-1 ml-3"
              onClick={() =>
                this.state.recording === "started"
                  ? this.stopRecording()
                  : this.startRecording()
              }
            >
              {this.state.recording === "stopped" ? (
                <>
                  <i className="fa fa-circle text-danger mr-2"></i> Gravar
                </>
              ) : this.state.recording === "started" ? (
                <>
                  <i className="fa fa-square mr-2"></i> Parar
                </>
              ) : this.state.recording === "starting" ? (
                <>
                  <CSpinner size="sm" color="danger" className="mr-2" />{" "}
                  Iniciando gravação...
                </>
              ) : this.state.recording === "saving" ? (
                <>
                  <CSpinner size="sm" color="white" className="mr-2" /> Salvando
                  gravação...
                </>
              ) : (
                <>
                  <CSpinner size="sm" color="white" className="mr-2" /> Parando
                  gravação...
                </>
              )}
            </CButton>
          )}
        </div>
        {!this.state.loading ? (
          <div className="d-flex align-items-center justify-content-center w-100 flex-1 bg-dark">
            {this.props.general.active_roles.role_id !== 7 ? (
              <JitsiTeacher
                room={this.getJitsiRoomName()}
                user={this.props.user.user.name}
                className="w-100 h-100"
                onStartRecording={() => this.onStartRecording()}
                onStopRecording={() => this.onStopRecording()}
                onJitsi={jitsi => this.setState({ jitsiObj: jitsi })}
              />
            ) : (
              <JitsiStudent
                room={this.getJitsiRoomName()}
                user={this.props.user.user.name}
                className="w-100 h-100"
                onJitsi={jitsi => this.setState({ jitsiObj: jitsi })}
              />
            )}
          </div>
        ) : (
          <div className="d-flex align-items-center justify-content-center w-100 flex-1 bg-dark">
            <CSpinner size="md" color="white" />
          </div>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

ClassroomJitsi.propTypes = {
  hideLayout: PropTypes.bool,
  guestLogin: PropTypes.bool
};

ClassroomJitsi.defaultProps = {
  hideLayout: true,
  guestLogin: false
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassroomJitsi);
